import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { UserService } from 'src/app/User/Service/user.service';

@Component({
    selector: 'app-affiliates',
    templateUrl: './affiliates.component.html',
    styleUrls: ['./../landing/landing.component.css', './affiliates.component.css'],
    standalone: false
})
export class AffiliatesComponent implements OnInit {

  @ViewChild('pricing') pricing;
  constructor(
    public auth: AuthService,
    public userService: UserService,
    private loader: LoadingService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.loader.HideLoading();
  }

  showPricing() {
    this.modalService.open(this.pricing, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }
  onClose() {
    this.modalService.dismissAll();
  }

}
